<div class="wrapper-content game-wrapper-full"
[class.color-1]="url=='incendios-forestales'"
[class.color-2]="url=='humedales'"
[style.background]="(url=='incendios-forestales')?'url('+'/assets/games/fuego-04.jpg'+')':'url('+'/assets/games/humedales-03.jpg'+')'">

  <div class="game-header fullwidth">
    <h5 class="legend">{{url}} {{(category!='todas')?' / Glosario':''}}</h5>
    <h1 *ngIf="category=='todas'"class="title">Glosario</h1>
    <h1 *ngIf="category!='todas'" class="title">{{category}}</h1>
    <a class="btn-back"  (click)="route.goTo('juego-inicio/'+url)" style="text-decoration: none;">
      <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
        <g id="Grupo_75" data-name="Grupo 75" transform="translate(-1142 -30)">
          <rect id="Rectángulo_145" data-name="Rectángulo 145" width="85" height="85" transform="translate(1142 30)" />
          <g id="Grupo_73" data-name="Grupo 73" transform="translate(1164.95 52.95)">
            <rect id="Rectángulo_3" data-name="Rectángulo 3" width="51" height="5.1"
              transform="translate(0 36.062) rotate(-45)" fill="#fff" />
            <rect id="Rectángulo_141" data-name="Rectángulo 141" width="51" height="5.1"
              transform="translate(3.606 0) rotate(45)" fill="#fff" />
          </g>
        </g>
      </svg>
    </a>
  </div>

  <a (click)="route.goTo('juego-glosario/'+url+'/todas')" *ngIf="category!='todas'" class="btn-back-2"
    style="z-index: 3">
    <svg xmlns="http://www.w3.org/2000/svg" width="85" height="85" viewBox="0 0 85 85">
      <g id="Grupo_87" data-name="Grupo 87" transform="translate(-1142 -30)">
        <rect id="Rectángulo_145" data-name="Rectángulo 145" width="85" height="85" transform="translate(1142 30)" />
        <path id="Trazado_35" data-name="Trazado 35" d="M2420,308.187l21.85,21.85,21.85-21.85"
          transform="translate(1503.537 -2369.5) rotate(90)" fill="none" stroke="#fff" stroke-width="7" />
      </g>
    </svg>
  </a>
  <!--  <div class="game-content" style="padding-top: 30px;">

  </div> -->

  <div class="container-fluid game-content transparent" style="padding-top: 30px;" *ngIf="category=='todas'">
    <div class="col-xs-12 col-md-6" [hidden]="search!=''" *ngFor="let area of areas">
      <div class="glossary-topic" (click)="route.goTo('juego-glosario/'+url+'/'+area.name)">
        {{area.title.es}}
      </div>
    </div>
  </div>

  <div class="container-fluid game-content transparent" style="padding-top: 30px;" *ngIf="category!='todas' &&  areas">
    <div class="col-12" *ngFor="let a of areas" [hidden]="a.name != category">
      <mat-accordion *ngIf="a.name == category">
        <mat-expansion-panel class="transparent" *ngFor="let item of a.webglossary">
          <mat-expansion-panel-header class="ts-background-5">
            <mat-panel-title>
              <h5 class="th-color-1"> {{item.name}}</h5>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p [innerHTML]="item.content"></p>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
